import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Chip } from "./Chip";
import { BetManager } from "../Managers/BetManager";

@engineComponent(ComponentTypes.DisplayObject)
export class ChipSelector extends ContainerElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static ChipSmallStyle = "CS_chip_small";
    private static ChipPool: Array<Chip> = [];

    public static getChip(betIndex: number): Chip {
        let chip: Chip;

        if (ChipSelector.ChipPool.length > 0) {
            chip = ChipSelector.ChipPool.pop();
        } else {
            chip = ChipSelector.createChip();
        }

        chip.setupChip(betIndex, BetManager.Chips[betIndex]);
        return chip;
    }

    private static createChip(): Chip {
        let chip = new Chip();
        let node: Element = document.createElement("Chip");
        node.setAttribute("Style", ChipSelector.ChipSmallStyle);
        node.setAttribute("Clone", "true");

        chip.create(node);
        return chip;
    }

    public static returnChip(chip: Chip): void {
        ChipSelector.ChipPool.push();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/ChipSelector.ts
 **/